import React from "react";
import { BaseOnboardingContainer } from "@components/onboarding/components/BaseOnboardingContainer";
import { LoginFlow } from "./LoginFlow/LoginFlow";
import styles from "./Login.module.scss";

export const Login: React.FC = () => (
    <BaseOnboardingContainer>
        <div className={styles.container}>
            <div className={styles.content}>
                <LoginFlow />
            </div>
        </div>
    </BaseOnboardingContainer>
);
